module.exports = __webpack_public_path__ + "media/images/captive_portal/CompanyManagement-1bd9a144990ce0f93bd5529d6af33731.svg";